import type { QuantityUnit } from 'containers/quantityUnits/types'

interface ItemWithQuantityProps {
    quantityValue: number
    unitSymbol: QuantityUnit['symbol'] | undefined
    itemName: string
}

const unitSymbolsWithSpace: QuantityUnit['symbol'][] = ['cups', 'fl.oz', 'lbs', 'oz', 'tbsp', 'tsp']

const ItemWithQuantity: React.FC<ItemWithQuantityProps> = ({ quantityValue, unitSymbol, itemName }) => {
    return (
        <p>
            <span>
                {quantityValue}
                {unitSymbol && unitSymbolsWithSpace.includes(unitSymbol) ? ' ' : ''}
                {unitSymbol || ''} {itemName}
            </span>
        </p>
    )
}

export default ItemWithQuantity
